

// import React, {
//   useEffect,
//   useState,
//   useRef
// } from "react";

// import axios from "axios";

// import { API } from "../config";

// import "../../style/EstudianteSimulacros.css";

// export default function EstudianteSimulacros() {

//   const token =
//     localStorage.getItem("token");

//   const headers = {
//     Authorization: `Bearer ${token}`
//   };

//   /* =====================================================
//      STATES
//   ===================================================== */

//   const [
//     simulacros,
//     setSimulacros
//   ] = useState([]);

//   const [
//     loading,
//     setLoading
//   ] = useState(true);

//   const [
//     loadingDetalle,
//     setLoadingDetalle
//   ] = useState(false);

//   const [
//     simulacroActivo,
//     setSimulacroActivo
//   ] = useState(null);

//   const [
//     preguntas,
//     setPreguntas
//   ] = useState([]);

//   const [
//     respuestas,
//     setRespuestas
//   ] = useState({});

//   const [
//     enviando,
//     setEnviando
//   ] = useState(false);

//   const [
//     resultado,
//     setResultado
//   ] = useState(null);

//   const [
//     promedioMaterias,
//     setPromedioMaterias
//   ] = useState([]);

//   const [
//     loadingPromedios,
//     setLoadingPromedios
//   ] = useState(false);

//   const [
//     tiempoRestante,
//     setTiempoRestante
//   ] = useState(0);

//   const intervalRef =
//     useRef(null);

//   const enviadoAutomaticoRef =
//     useRef(false);

//   /* =====================================================
//      FORMATEAR TIEMPO
//   ===================================================== */

//   const formatearTiempo = (
//     segundos
//   ) => {

//     const horas =
//       Math.floor(segundos / 3600);

//     const minutos =
//       Math.floor(
//         (segundos % 3600) / 60
//       );

//     const secs =
//       segundos % 60;

//     return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
//   };

//   /* =====================================================
//      FETCH SIMULACROS
//   ===================================================== */

//   const fetchSimulacros = async () => {

//     try {

//       setLoading(true);

//       const res = await axios.get(
//         `${API}/simulacros/estudiante/mis-simulacros`,
//         { headers }
//       );

//       setSimulacros(
//         Array.isArray(
//           res.data.simulacros
//         )
//           ? res.data.simulacros
//           : []
//       );

//     } catch (err) {

//       console.error(
//         "❌ Error simulacros:",
//         err.response?.data || err.message
//       );

//     } finally {

//       setLoading(false);
//     }
//   };

//   /* =====================================================
//      VER RESULTADO DETALLADO
//   ===================================================== */

//   const verResultadoSimulacro = async (
//     simulacro_id
//   ) => {

//     try {

//       setLoadingDetalle(true);

//       setResultado(null);

//       setSimulacroActivo(null);

//       const [
//         simulacroRes,
//         resultadoRes
//       ] = await Promise.all([

//         axios.get(
//           `${API}/simulacros/estudiante/ver/${simulacro_id}`,
//           { headers }
//         ),

//         axios.get(
//           `${API}/simulacros/estudiante/resultado-detallado/${simulacro_id}`,
//           { headers }
//         )
//       ]);

//       setSimulacroActivo(
//         simulacroRes.data.simulacro
//       );

//       setResultado(
//         resultadoRes.data.resultado || null
//       );

//       setPreguntas([]);

//       setRespuestas({});

//       setTiempoRestante(0);

//     } catch (err) {

//       console.error(err);

//       alert(
//         err.response?.data?.message ||
//         "Error cargando resultado"
//       );

//     } finally {

//       setLoadingDetalle(false);
//     }
//   };

//   /* =====================================================
//      ABRIR SIMULACRO
//   ===================================================== */

//   const abrirSimulacro = async (
//     simulacro_id
//   ) => {

//     try {

//       setLoadingDetalle(true);

//       setResultado(null);

//       const res = await axios.get(
//         `${API}/simulacros/estudiante/ver/${simulacro_id}`,
//         { headers }
//       );

//       const simulacro =
//         res.data.simulacro;

//       setSimulacroActivo(
//         simulacro
//       );

//       setPreguntas(
//         Array.isArray(
//           res.data.preguntas
//         )
//           ? res.data.preguntas
//           : []
//       );

//       setRespuestas({});

//       enviadoAutomaticoRef.current =
//         false;

//       const tiempoInicial =
//         Number(
//           simulacro?.tiempo_minutos || 120
//         ) * 60;

//       setTiempoRestante(
//         tiempoInicial
//       );

//     } catch (err) {

//       console.error(err);

//       alert(
//         err.response?.data?.message ||
//         "Error cargando simulacro"
//       );

//     } finally {

//       setLoadingDetalle(false);
//     }
//   };

//   /* =====================================================
//      CONTADOR
//   ===================================================== */

//   useEffect(() => {

//     if (
//       !simulacroActivo ||
//       resultado
//     ) {

//       if (intervalRef.current) {

//         clearInterval(
//           intervalRef.current
//         );
//       }

//       return;
//     }

//     intervalRef.current =
//       setInterval(() => {

//         setTiempoRestante(prev => {

//           if (prev <= 1) {

//             clearInterval(
//               intervalRef.current
//             );

//             if (
//               !enviadoAutomaticoRef.current
//             ) {

//               enviadoAutomaticoRef.current =
//                 true;

//               enviarSimulacro(true);
//             }

//             return 0;
//           }

//           return prev - 1;
//         });

//       }, 1000);

//     return () => {

//       if (intervalRef.current) {

//         clearInterval(
//           intervalRef.current
//         );
//       }
//     };

//   }, [
//     simulacroActivo,
//     resultado
//   ]);

//   /* =====================================================
//      SELECCIONAR RESPUESTA
//   ===================================================== */

//   const seleccionarRespuesta = (
//     pregunta_id,
//     opcion_id
//   ) => {

//     setRespuestas(prev => ({
//       ...prev,
//       [pregunta_id]: opcion_id
//     }));
//   };

//   /* =====================================================
//      ENVIAR SIMULACRO
//   ===================================================== */

//   const enviarSimulacro = async (
//     automatico = false
//   ) => {

//     try {

//       if (!simulacroActivo) {
//         return;
//       }

//       if (
//         Object.keys(respuestas)
//           .length === 0 &&
//         !automatico
//       ) {

//         return alert(
//           "Debes responder preguntas"
//         );
//       }

//       setEnviando(true);

//       const respuestasArray =
//         Object.entries(
//           respuestas
//         ).map(
//           ([
//             pregunta_id,
//             opcion_id
//           ]) => ({
//             pregunta_id:
//               Number(
//                 pregunta_id
//               ),

//             opcion_id:
//               Number(opcion_id)
//           })
//         );

//       await axios.post(
//         `${API}/simulacros/estudiante/responder`,
//         {
//           simulacro_id:
//             simulacroActivo.id,

//           respuestas:
//             respuestasArray
//         },
//         { headers }
//       );

//       clearInterval(
//         intervalRef.current
//       );

//       await fetchSimulacros();

//       await verResultadoSimulacro(
//         simulacroActivo.id
//       );

//       if (!automatico) {

//         alert(
//           "✅ Simulacro enviado correctamente"
//         );
//       }

//     } catch (err) {

//       console.error(err);

//       alert(
//         err.response?.data?.message ||
//         "Error enviando simulacro"
//       );

//     } finally {

//       setEnviando(false);
//     }
//   };

//   /* =====================================================
//      CERRAR MODAL
//   ===================================================== */

//   const cerrarModal = () => {

//     clearInterval(
//       intervalRef.current
//     );

//     setSimulacroActivo(
//       null
//     );

//     setPreguntas([]);

//     setRespuestas({});

//     setResultado(null);

//     setTiempoRestante(0);

//     setPromedioMaterias([]);
//   };

//   /* =====================================================
//      INIT
//   ===================================================== */

//   useEffect(() => {

//     fetchSimulacros();

//   }, []);

//   /* =====================================================
//      RENDER
//   ===================================================== */

//   return (

//     <div className="estudiante-simulacros-container">

//       <h2>
//         📝 Mis Simulacros ICFES
//       </h2>

//       {
//         loading ? (

//           <div className="loading-box">
//             Cargando simulacros...
//           </div>

//         ) : simulacros.length === 0 ? (

//           <div className="empty-box">
//             No tienes simulacros disponibles
//           </div>

//         ) : (

//           <div className="simulacros-grid">

//             {
//               simulacros.map((s) => (

//                 <div
//                   key={s.id}
//                   className="simulacro-card"
//                 >

//                   <h3>
//                     📘 {s.titulo}
//                   </h3>

//                   <p>
//                     {s.descripcion}
//                   </p>

//                   <div className="simulacro-info">

//                     <div>
//                       ⏱️
//                       {" "}
//                       {s.tiempo_minutos}
//                       {" "}
//                       minutos
//                     </div>

//                     <div>
//                       📅
//                       {" "}
//                       {s.fecha_publicacion}
//                     </div>

//                     <div>

//                       {
//                         s.estado_respuesta ===
//                         "respondido"
//                           ? (
//                             <span className="estado-respondido">
//                               ✅ YA RESPONDIDO
//                             </span>
//                           )
//                           : (
//                             <span className="estado-disponible">
//                               🟣 DISPONIBLE
//                             </span>
//                           )
//                       }

//                     </div>

//                   </div>

//                   {
//                     s.estado_respuesta ===
//                     "respondido" ? (

//                       <button
//                         onClick={() =>
//                           verResultadoSimulacro(
//                             s.id
//                           )
//                         }
//                       >
//                         📊 Ver resultado
//                       </button>

//                     ) : (

//                       <button
//                         onClick={() =>
//                           abrirSimulacro(
//                             s.id
//                           )
//                         }
//                       >
//                         Presentar simulacro
//                       </button>
//                     )
//                   }

//                 </div>
//               ))
//             }

//           </div>
//         )
//       }

//       {
//         simulacroActivo && (

//           <div className="modal-overlay">

//             <div className="modal-simulacro">

//               <h2>
//                 📘
//                 {" "}
//                 {simulacroActivo.titulo}
//               </h2>

//               <p>
//                 {
//                   simulacroActivo.descripcion
//                 }
//               </p>

//               {
//                 !resultado && (

//                   <div
//                     className={
//                       tiempoRestante <= 300
//                         ? "cronometro-box alerta"
//                         : "cronometro-box"
//                     }
//                   >
//                     ⏱️ Tiempo restante:
//                     {" "}
//                     {
//                       formatearTiempo(
//                         tiempoRestante
//                       )
//                     }
//                   </div>
//                 )
//               }

//               {
//                 loadingDetalle ? (

//                   <div className="loading-box">
//                     Cargando...
//                   </div>

//                 ) : resultado ? (

//                   <div className="resultado-box">

//                     <h3>
//                       🎯 Resultado ICFES
//                     </h3>

//                     <div>
//                       ✅ Correctas:
//                       {" "}
//                       {resultado.correctas || 0}
//                     </div>

//                     <div>
//                       ❌ Incorrectas:
//                       {" "}
//                       {resultado.incorrectas || 0}
//                     </div>

//                     <div>
//                       📊 Puntaje:
//                       {" "}
//                       {resultado.puntaje || 0}%
//                     </div>

//                     <div>
//                       🏆 Nivel:
//                       {" "}
//                       {resultado.nivel || "N/A"}
//                     </div>

//                     <div>
//                       📈 Percentil:
//                       {" "}
//                       {resultado.percentil || 0}
//                     </div>

//                     <hr />

//                     <h4>
//                       📚 Desempeño por materia
//                     </h4>

//                     {
//                       Array.isArray(
//                         resultado.materias
//                       ) &&
//                       resultado.materias.map(
//                         (m, i) => (

//                           <div
//                             key={i}
//                             className="materia-resultado"
//                             style={{
//                               marginBottom: "15px",
//                               background: "#ffffff",
//                               padding: "15px",
//                               borderRadius: "12px",
//                               color: "#111827"
//                             }}
//                           >

//                             <strong>
//                               {m.materia}
//                             </strong>

//                             <div>
//                               ✅
//                               {" "}
//                               {m.correctas}
//                               {" "}
//                               |
//                               {" "}
//                               ❌
//                               {" "}
//                               {m.incorrectas}
//                             </div>

//                             <div>
//                               📊
//                               {" "}
//                               {m.promedio}%
//                             </div>

//                           </div>
//                         )
//                       )
//                     }

//                     {
//                       Array.isArray(
//                         resultado.recomendaciones
//                       ) &&
//                       resultado.recomendaciones.length > 0 && (
//                         <>

//                           <hr />

//                           <h4>
//                             🧠 Recomendaciones
//                           </h4>

//                           <ul>

//                             {
//                               resultado.recomendaciones.map(
//                                 (
//                                   r,
//                                   i
//                                 ) => (

//                                   <li key={i}>

//                                     <strong>
//                                       {r.materia}:
//                                     </strong>

//                                     {" "}
//                                     {
//                                       r.recomendacion
//                                     }

//                                   </li>
//                                 )
//                               )
//                             }

//                           </ul>

//                         </>
//                       )
//                     }

//                     <button
//                       className="btn-cerrar"
//                       onClick={cerrarModal}
//                     >
//                       Cerrar
//                     </button>

//                   </div>

//                 ) : (

//                   <>

//                     {
//                       preguntas.map(
//                         (
//                           pregunta,
//                           index
//                         ) => (

//                           <div
//                             key={
//                               pregunta.id
//                             }
//                             className="pregunta-box"
//                           >

//                             <h4>
//                               {index + 1}.
//                               {" "}
//                               {
//                                 pregunta.enunciado
//                               }
//                             </h4>

//                             <div className="opciones-box">

//                               {
//                                 Array.isArray(
//                                   pregunta.opciones
//                                 ) &&
//                                 pregunta.opciones.map(
//                                   (
//                                     op
//                                   ) => (

//                                     <label
//                                       key={
//                                         op.id
//                                       }
//                                       className="opcion-item"
//                                     >

//                                       <input
//                                         type="radio"
//                                         name={`pregunta_${pregunta.id}`}
//                                         checked={
//                                           respuestas[
//                                             pregunta.id
//                                           ] ===
//                                           op.id
//                                         }
//                                         onChange={() =>
//                                           seleccionarRespuesta(
//                                             pregunta.id,
//                                             op.id
//                                           )
//                                         }
//                                       />

//                                       {op.opcion}

//                                     </label>
//                                   )
//                                 )
//                               }

//                             </div>

//                           </div>
//                         )
//                       )
//                     }

//                     <button
//                       className="btn-enviar"
//                       onClick={() =>
//                         enviarSimulacro(false)
//                       }
//                       disabled={
//                         enviando
//                       }
//                     >
//                       {
//                         enviando
//                           ? "Enviando..."
//                           : "Finalizar simulacro"
//                       }
//                     </button>

//                     <button
//                       className="btn-cerrar"
//                       onClick={cerrarModal}
//                     >
//                       Cerrar
//                     </button>

//                   </>
//                 )
//               }

//             </div>

//           </div>
//         )
//       }

//     </div>
//   );
// }

//
import React, {
  useEffect,
  useState,
  useRef
} from "react";

import axios from "axios";

import { API } from "../config";

import "../../style/EstudianteSimulacros.css";

export default function EstudianteSimulacros() {

  const token =
    localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`
  };

  /* =====================================================
     STATES
  ===================================================== */

  const [
    simulacros,
    setSimulacros
  ] = useState([]);

  const [
    loading,
    setLoading
  ] = useState(true);

  const [
    loadingDetalle,
    setLoadingDetalle
  ] = useState(false);

  const [
    simulacroActivo,
    setSimulacroActivo
  ] = useState(null);

  const [
    preguntas,
    setPreguntas
  ] = useState([]);

  const [
    respuestas,
    setRespuestas
  ] = useState({});

  const [
    enviando,
    setEnviando
  ] = useState(false);

  const [
    resultado,
    setResultado
  ] = useState(null);

  const [
    tiempoRestante,
    setTiempoRestante
  ] = useState(0);

  const intervalRef =
    useRef(null);

  const enviadoAutomaticoRef =
    useRef(false);

  /* =====================================================
     FORMATEAR TIEMPO
  ===================================================== */

  const formatearTiempo = (
    segundos
  ) => {

    const horas =
      Math.floor(segundos / 3600);

    const minutos =
      Math.floor(
        (segundos % 3600) / 60
      );

    const secs =
      segundos % 60;

    return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  /* =====================================================
     FETCH SIMULACROS
  ===================================================== */

  const fetchSimulacros = async () => {

    try {

      setLoading(true);

      const res = await axios.get(
        `${API}/simulacros/estudiante/mis-simulacros`,
        { headers }
      );

      setSimulacros(
        Array.isArray(
          res.data.simulacros
        )
          ? res.data.simulacros
          : []
      );

    } catch (err) {

      console.error(
        "❌ Error simulacros:",
        err.response?.data || err.message
      );

    } finally {

      setLoading(false);
    }
  };

  /* =====================================================
     VER RESULTADO
  ===================================================== */

  const verResultadoSimulacro = async (
    simulacro_id
  ) => {

    try {

      setLoadingDetalle(true);

      setResultado(null);

      setSimulacroActivo(null);

      const resultadoRes =
        await axios.get(
          `${API}/simulacros/estudiante/resultado-detallado/${simulacro_id}`,
          { headers }
        );

      setResultado(
        resultadoRes.data.resultado || null
      );

      setSimulacroActivo({
        id: simulacro_id
      });

      setPreguntas([]);

      setRespuestas({});

      setTiempoRestante(0);

    } catch (err) {

      console.error(err);

      alert(
        err.response?.data?.message ||
        "Error cargando resultado"
      );

    } finally {

      setLoadingDetalle(false);
    }
  };

  /* =====================================================
     ABRIR SIMULACRO
  ===================================================== */

  const abrirSimulacro = async (
    simulacro_id
  ) => {

    try {

      setLoadingDetalle(true);

      setResultado(null);

      const res = await axios.get(
        `${API}/simulacros/estudiante/ver/${simulacro_id}`,
        { headers }
      );

      const simulacro =
        res.data.simulacro;

      setSimulacroActivo(
        simulacro
      );

      setPreguntas(
        Array.isArray(
          res.data.preguntas
        )
          ? res.data.preguntas
          : []
      );

      setRespuestas({});

      enviadoAutomaticoRef.current =
        false;

      const tiempoInicial =
        Number(
          simulacro?.tiempo_minutos || 120
        ) * 60;

      setTiempoRestante(
        tiempoInicial
      );

    } catch (err) {

      console.error(err);

      alert(
        err.response?.data?.message ||
        "Error cargando simulacro"
      );

    } finally {

      setLoadingDetalle(false);
    }
  };

  /* =====================================================
     CONTADOR
  ===================================================== */

  useEffect(() => {

    if (
      !simulacroActivo ||
      resultado
    ) {

      if (intervalRef.current) {

        clearInterval(
          intervalRef.current
        );
      }

      return;
    }

    intervalRef.current =
      setInterval(() => {

        setTiempoRestante(prev => {

          if (prev <= 1) {

            clearInterval(
              intervalRef.current
            );

            if (
              !enviadoAutomaticoRef.current
            ) {

              enviadoAutomaticoRef.current =
                true;

              enviarSimulacro(true);
            }

            return 0;
          }

          return prev - 1;
        });

      }, 1000);

    return () => {

      if (intervalRef.current) {

        clearInterval(
          intervalRef.current
        );
      }
    };

  }, [
    simulacroActivo,
    resultado
  ]);

  /* =====================================================
     SELECCIONAR RESPUESTA
  ===================================================== */

  const seleccionarRespuesta = (
    pregunta_id,
    opcion_id
  ) => {

    setRespuestas(prev => ({
      ...prev,
      [pregunta_id]: opcion_id
    }));
  };

  /* =====================================================
     ENVIAR SIMULACRO
  ===================================================== */

  const enviarSimulacro = async (
    automatico = false
  ) => {

    try {

      if (!simulacroActivo) {
        return;
      }

      if (
        Object.keys(respuestas)
          .length === 0 &&
        !automatico
      ) {

        return alert(
          "Debes responder preguntas"
        );
      }

      setEnviando(true);

      const respuestasArray =
        Object.entries(
          respuestas
        ).map(
          ([
            pregunta_id,
            opcion_id
          ]) => ({
            pregunta_id:
              Number(
                pregunta_id
              ),

            opcion_id:
              Number(opcion_id)
          })
        );

      await axios.post(
        `${API}/simulacros/estudiante/responder`,
        {
          simulacro_id:
            simulacroActivo.id,

          respuestas:
            respuestasArray
        },
        { headers }
      );

      clearInterval(
        intervalRef.current
      );

      await fetchSimulacros();

      await verResultadoSimulacro(
        simulacroActivo.id
      );

      if (!automatico) {

        alert(
          "✅ Simulacro enviado correctamente"
        );
      }

    } catch (err) {

      console.error(err);

      alert(
        err.response?.data?.message ||
        "Error enviando simulacro"
      );

    } finally {

      setEnviando(false);
    }
  };

  /* =====================================================
     CERRAR MODAL
  ===================================================== */

  const cerrarModal = () => {

    clearInterval(
      intervalRef.current
    );

    setSimulacroActivo(
      null
    );

    setPreguntas([]);

    setRespuestas({});

    setResultado(null);

    setTiempoRestante(0);
  };

  /* =====================================================
     INIT
  ===================================================== */

  useEffect(() => {

    fetchSimulacros();

  }, []);

  /* =====================================================
     RENDER
  ===================================================== */

  return (

    <div className="estudiante-simulacros-container">

      <h2>
        📝 Mis Simulacros ICFES
      </h2>

      {
        loading ? (

          <div className="loading-box">
            Cargando simulacros...
          </div>

        ) : simulacros.length === 0 ? (

          <div className="empty-box">
            No tienes simulacros disponibles
          </div>

        ) : (

          <div className="simulacros-grid">

            {
              simulacros.map((s) => (

                <div
                  key={s.id}
                  className="simulacro-card"
                >

                  <h3>
                    📘 {s.titulo}
                  </h3>

                  <p>
                    {s.descripcion}
                  </p>

                  <div className="simulacro-info">

                    <div>
                      ⏱️
                      {" "}
                      {s.tiempo_minutos}
                      {" "}
                      minutos
                    </div>

                    <div>
                      📅
                      {" "}
                      {s.fecha_publicacion}
                    </div>

                    <div>

                      {
                        s.estado_respuesta ===
                        "respondido"
                          ? (
                            <span className="estado-respondido">
                              ✅ YA RESPONDIDO
                            </span>
                          )
                          : (
                            <span className="estado-disponible">
                              🟣 DISPONIBLE
                            </span>
                          )
                      }

                    </div>

                  </div>

                  {
                    s.estado_respuesta ===
                    "respondido" ? (

                      <button
                        onClick={() =>
                          verResultadoSimulacro(
                            s.id
                          )
                        }
                      >
                        📊 Ver resultado
                      </button>

                    ) : (

                      <button
                        onClick={() =>
                          abrirSimulacro(
                            s.id
                          )
                        }
                      >
                        Presentar simulacro
                      </button>
                    )
                  }

                </div>
              ))
            }

          </div>
        )
      }

      {
        simulacroActivo && (

          <div className="modal-overlay">

            <div className="modal-simulacro">

              {/* =====================================================
                 TITULO Y DESCRIPCION
              ===================================================== */}

              {
                simulacroActivo.titulo && (
                  <>

                    <h2>
                      📘
                      {" "}
                      {simulacroActivo.titulo}
                    </h2>

                    <p>
                      {
                        simulacroActivo.descripcion
                      }
                    </p>

                  </>
                )
              }

              {/* =====================================================
                 CRONOMETRO
              ===================================================== */}

              {
                !resultado && (

                  <div
                    className={
                      tiempoRestante <= 300
                        ? "cronometro-box alerta"
                        : "cronometro-box"
                    }
                  >
                    ⏱️ Tiempo restante:
                    {" "}
                    {
                      formatearTiempo(
                        tiempoRestante
                      )
                    }
                  </div>
                )
              }

              {
                loadingDetalle ? (

                  <div className="loading-box">
                    Cargando...
                  </div>

                ) : resultado ? (

                  <div className="resultado-box">

                    <h3>
                      🎯 Resultado ICFES
                    </h3>

                    <div>
                      ✅ Correctas:
                      {" "}
                      {resultado.correctas || 0}
                    </div>

                    <div>
                      ❌ Incorrectas:
                      {" "}
                      {resultado.incorrectas || 0}
                    </div>

                    <div>
                      📊 Puntaje:
                      {" "}
                      {resultado.puntaje || 0}%
                    </div>

                    <div>
                      🏆 Nivel:
                      {" "}
                      {resultado.nivel || "N/A"}
                    </div>

                    <div>
                      📈 Percentil:
                      {" "}
                      {resultado.percentil || 0}
                    </div>

                    <hr />

                    <h4>
                      📚 Desempeño por materia
                    </h4>

                    {
                      Array.isArray(
                        resultado.materias
                      ) &&
                      resultado.materias.map(
                        (m, i) => (

                          <div
                            key={i}
                            className="materia-resultado"
                          >

                            <strong>
                              {m.materia}
                            </strong>

                            <div>
                              ✅ {m.correctas}
                              {" "}
                              |
                              {" "}
                              ❌ {m.incorrectas}
                            </div>

                            <div>
                              📊
                              {" "}
                              {m.porcentaje || 0}%
                            </div>

                            <div>
                              🏆
                              {" "}
                              {m.nivel}
                            </div>

                          </div>
                        )
                      )
                    }

                    {
                      Array.isArray(
                        resultado.recomendaciones
                      ) &&
                      resultado.recomendaciones.length > 0 && (
                        <>

                          <hr />

                          <h4>
                            🧠 Recomendaciones
                          </h4>

                          <ul>

                            {
                              resultado.recomendaciones.map(
                                (
                                  r,
                                  i
                                ) => (

                                  <li key={i}>

                                    <strong>
                                      {r.materia}:
                                    </strong>

                                    {" "}
                                    {
                                      r.recomendacion
                                    }

                                  </li>
                                )
                              )
                            }

                          </ul>

                        </>
                      )
                    }

                    <button
                      className="btn-cerrar"
                      onClick={cerrarModal}
                    >
                      Cerrar
                    </button>

                  </div>

                ) : (

                  <>

                    {
                      preguntas.map(
                        (
                          pregunta,
                          index
                        ) => (

                          <div
                            key={
                              pregunta.id
                            }
                            className="pregunta-box"
                          >

                            <div className="pregunta-header">

                              <div className="pregunta-materia">
                                📚
                                {" "}
                                {
                                  pregunta.materia ||
                                  "GENERAL"
                                }
                              </div>

                              <h4>
                                {index + 1}.
                                {" "}
                                {
                                  pregunta.enunciado
                                }
                              </h4>

                            </div>

                            {
                              pregunta.imagen_url && (

                                <img
                                  src={
                                    pregunta.imagen_url
                                  }
                                  alt="pregunta"
                                  className="pregunta-img"
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                  }}
                                />
                              )
                            }

                            <div className="opciones-box">

                              {
                                Array.isArray(
                                  pregunta.opciones
                                ) &&
                                pregunta.opciones.map(
                                  (
                                    op
                                  ) => (

                                    <label
                                      key={
                                        op.id
                                      }
                                      className="opcion-item"
                                    >

                                      <input
                                        type="radio"
                                        name={`pregunta_${pregunta.id}`}
                                        checked={
                                          respuestas[
                                            pregunta.id
                                          ] ===
                                          op.id
                                        }
                                        onChange={() =>
                                          seleccionarRespuesta(
                                            pregunta.id,
                                            op.id
                                          )
                                        }
                                      />

                                      {op.opcion}

                                    </label>
                                  )
                                )
                              }

                            </div>

                          </div>
                        )
                      )
                    }

                    <button
                      className="btn-enviar"
                      onClick={() =>
                        enviarSimulacro(false)
                      }
                      disabled={
                        enviando
                      }
                    >
                      {
                        enviando
                          ? "Enviando..."
                          : "Finalizar simulacro"
                      }
                    </button>

                    <button
                      className="btn-cerrar"
                      onClick={cerrarModal}
                    >
                      Cerrar
                    </button>

                  </>
                )
              }

            </div>

          </div>
        )
      }

    </div>
  );
}